<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="baseView.mode"
    :tabs="tabs"
    :selectedIndex="selectedIndex"
    :formsConfig="formsConfig"
  >
    <template #headerContent>
      <GcHeaderContentStatic title="Goods Received" />
    </template>
    <div>
      <gc-filter-split-view
        :showLeftContainer="showFilterLeftContainer"
        :showRightContainer="showFilterRightContainer"
      >
        <template #leftContent>
          <dx-data-grid
            :data-source="dataSourceConfig"
            @selection-changed="onSelectionChanged"
            :height="gridHeight"
            :columns="columns"
            @context-menu-preparing="onContextMenuPreparing($event, rowSelect)"
            @content-ready="addGridNoResults($event)"
            @toolbar-preparing="onToolbarPreparing($event)"
          >
            <template #status-cell-template="{ data }">
              <gc-status-chip :status="data.data.Status" />
            </template>

            <template #supplier-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.SupplierName"
                :code="String(data.data.SupplierCode)"
              />
            </template>
          </dx-data-grid>
        </template>
        <template #rightContent>
          <gc-advance-filter-panel
            :toolbar="filterToolbar"
            :filterFormHeight="filterFormHeight"
            :sideBarTabs="sideBarTabs"
            :filterFormItems="filterFormItems"
            :filterModel="getAdvanceFilterModel"
            :isJson="false"
            :screenType="'goods-return-list'"
            :data-source-config="dataSourceConfig"
            :initial-filter="initialFilter"
          >
          </gc-advance-filter-panel>
        </template>
      </gc-filter-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
import { GoodsReturnListService } from "../../_services/api/purchasing/goods-return-list.service";
import BaseViewMixin from "../../v1/_mixins/base.view";
import { tabAccessControl } from "../../_helpers/access-control";

export default {
  props: {},
  mixins: [BaseViewMixin],
  data() {
    return {
      rowSelect: {
        view: this,
        page: "goods-return",
        mode: "review",
        idProperty: "Code",
      },

      advanceFilterModel: {
        SupplierCode: "",
        DateIn: null,
        DateReceived: null,
      },
      noDataMessage: {
        addNew: {
          class: "add-new",
          title: "No Goods In",
          message: "Get Started, Add a PO to Receive.",
        },
      },
    };
  },
  components: {},
  computed: {
    dataSourceConfig() {
      return GoodsReturnListService.dataSourceConfig("api/GoodsInList", {
        select: [
          "Code",
          "PurchaseOrderCode",
          "SupplierCode",
          "Status",
          "FriendlyStatus",
          "SupplierName",
          "DateReceived",
        ],
        // sort: [{ selector: "Code", desc: true }],
        filter: [["IsReturnable", "=", "Y"]],
      });
    },
    initialFilter() {
      return [["IsReturnable", "=", "Y"]];
    },
    filterFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: this.parseFormColumns([
            {
              dataField: "SupplierCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Supplier",
              editorOptions: {
                dataSource: GoodsReturnListService.dataSourceConfig(
                  "api/Supplier",
                  {
                    filter: [["Inactive", "=", "N"]],
                    sort: [{ selector: "Name", asc: true }],
                  }
                ),
                valueExpr: "Code",
                displayExpr: "Name",
                searchExpr: ["Code", "Name"],
                searchMode: "contains",
                searchEnabled: true,
                itemTemplate: "supplier-item-template",
              },
            },
            {
              dataField: "DateReceived",
              gcType: "Date",
              editorType: "DxDateBox",
              gcLabel: "Date Received",
              editorOptions: {
                editorType: "DxDateBox",
                filterCode: "DateReceived",
              },
            },
          ]),
        },
      ];
    },
    getAdvanceFilterModel() {
      return this.advanceFilterModel;
    },
    tabs() {
      var tabs = [
        {
          text: "All",
          path: `/purchase-order`,
          applicationFeatureCode: "PurchaseOrder",
        },
        {
          text: "To Receive",
          path: `/goods-in`,
          applicationFeatureCode: "GoodsIn",
        },
        {
          text: "Received",
          path: `/goods-in-review`,
          applicationFeatureCode: "GoodsIn",
        },
        {
          text: "To Return",
          path: `/goods-return`,
          applicationFeatureCode: "GoodsReturn",
        },
      ];
      return tabAccessControl(tabs);
    },
    columns() {
      return this.parseGridColumns("transaction", [
        {
          gcLabel: "Goods In",
          dataField: "Code",
          gcType: "Decimal-TransactionNo",
          gcSubType: "PrimaryTransactionNo",
        },
        {
          gcLabel: "Purchase Order",
          dataField: "PurchaseOrderCode",
          gcType: "Decimal-TransactionNo",
          gcSubType: "TransactionNo",
        },
        {
          gcLabel: "Supplier",
          dataField: "SupplierName",
          cellTemplate: "supplier-cell-template",
          gcType: "String",
          minWidth: this.gridColumnMinWidth(100),
          gcSubType: "RelatedRecord",
          gcExport: ["SupplierCode", "SupplierName"],
        },
        {
          gcLabel: "Date Received",
          dataField: "DateReceived",
          gcType: "Date",
        },

        {
          gcLabel: "Supplier Code",
          dataField: "SupplierCode",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
        },
        {
          gcLabel: "Supplier Name",
          dataField: "SupplierName",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenDescription",
        },
      ]);
    },
  },
  methods: {
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "searchPanel" && item.name !== "columnChooserButton"
        );
      });

      searchPanel.location = "after";
      e.toolbarOptions.items.unshift(searchPanel, columnChooserButton, {
        location: "after",
        locateinmenu: "auto",
        widget: "dxButton",
        options: {
          validationGroup: "formsData",
          icon: "filter",
          elementAttr: { id: "filter-btn" },
          onClick: () => {
            this.showFilterRightContainer = !this.showFilterRightContainer;
            var item = document.getElementById("filter-btn");
            this.$logger.debug("item ", item);
            item.classList.add("dx-state-invisible");
          },
        },
      });
    },

    onSelectionChanged({ selectedRowsData }) {
      if (this.formsConfig.editableOption) {
        this.$router.push({
          path: `/goods-return/edit/${selectedRowsData[0].Code}`,
        });
      } else if (this.formsConfig.reviewOption) {
        this.$router.push({
          path: `/goods-return/review/${selectedRowsData[0].Code}`,
        });
      }
    },
  },
  created() {
    this.selectedIndex = 3;
  },
};
</script>
